import { ALL_FILTER_OPTION } from 'components/lib/constants';

export const PHOTOS_FILTER_OPTIONS = [
  ALL_FILTER_OPTION,
  { label: 'Exterior Front', value: 'Exterior Front' },
  { label: 'Common Area', value: 'Common Area' },
  { label: 'Apartment Image', value: 'Apartment Image' },
  { label: 'Dining Room', value: 'Dining Room' },
  { label: 'Menu', value: 'Menu' },
  { label: 'Activity Calendar', value: 'Activity Calendar' },
  { label: 'Other Image', value: 'Other Image' },
];
